export enum GlobalMessages {
  filtersText = "global.filtersText",
  activeText = "global.activeText",
  inactiveText = "global.inactiveText",
  saveText = "global.saveText",
  columnActions = "global.columns.columnActions",
  buttonAdd = "global.buttons.buttonAdd",
  buttonDelete = "buttonDelete",
  buttonRefresh = "global.buttons.buttonRefresh",
  buttonCancel = "global.buttons.buttonCancel",
  buttonConfirm = "global.buttons.buttonConfirm",
  entityUser = "global.entities.entityUser",
  yesText = "global.yesText",
  noText = "global.noText",
  resetPasswordText = "global.resetPasswordText",
  logout = "global.logout",
  editUser = "global.editUser",
  invalidFormInputs = "global.validations.invalidFormInputs",
  toastWarning = "global.toast.warning",
  errorText = "global.errorText",
  warningTitleText = "global.warningTitleText",
  warningMessageText = "global.warningMessageText",
  selectAllText = "global.selectAllText",
  removeAllText = "global.removeAllText",
  noRecordsFoundText = "global.NoRecordsFoundText",
  alert = "global.alert",
  loading = "global.loading",
  accessDenied = "global.accessDenied",
  insufficientPermissions = "global.insufficientPermissions",
}

export interface TranslationGlobalMessages {
  [GlobalMessages.filtersText]: string;
  [GlobalMessages.activeText]: string;
  [GlobalMessages.inactiveText]: string;
  [GlobalMessages.saveText]: string;
  [GlobalMessages.columnActions]: string;
  [GlobalMessages.buttonAdd]: string;
  [GlobalMessages.buttonDelete]: string;
  [GlobalMessages.buttonRefresh]: string;
  [GlobalMessages.buttonCancel]: string;
  [GlobalMessages.buttonConfirm]: string;
  [GlobalMessages.entityUser]: string;
  [GlobalMessages.yesText]: string;
  [GlobalMessages.noText]: string;
  [GlobalMessages.resetPasswordText]: string;
  [GlobalMessages.logout]: string;
  [GlobalMessages.editUser]: string;
  [GlobalMessages.invalidFormInputs]: string;
  [GlobalMessages.toastWarning]: string;
  [GlobalMessages.errorText]: string;
  [GlobalMessages.warningTitleText]: string;
  [GlobalMessages.selectAllText]: string;
  [GlobalMessages.removeAllText]: string;
  [GlobalMessages.noRecordsFoundText]: string;
  [GlobalMessages.loading]: string;
  [GlobalMessages.accessDenied]: string;
  [GlobalMessages.insufficientPermissions]: string;
}
